jQuery(($) => {

    $('.a-bible-verse__bible').click(function () {
        if ($(window).width() <= 600) {
            $(this).parent().toggleClass('a-bible-verse--open');
        }
    });

});